const CompanyUser = () => {
  return <div>CompanyUser page</div>;
};

export default CompanyUser;
